import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  ListName: 'ListName',
  Active: 'Active',
};
const initialFilterState = {
  ListName: '',
  Active: true,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'ListName',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'listSearch';
const listSearchSlice = createSearchPageSlice({
  sliceName,
  initialFilterState,
  filterFields,
  initialPageState
});

export const listSearchActions = listSearchSlice.actions;
export default listSearchSlice.reducer;
